import { Button, Form, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import AgentApplicationSearch from "./AgentApplicationSearch";
import { useModalForm } from "../../../../../utils/hooks/useModalForm";

const AgentApplication = (props) => {
  const { status } = props; // PENDING / ASSIGNED / DISBURSED / REJECTED
  const [isFetching, setIsFetching] = useState(true);
  const [search, setSearch] = useState({ page: 1 });
  const [rowcount, setRowcount] = useState(0);
  const [data, setData] = useState([]);
  const [agents, setAgents] = useState([]);
  const [editData, setEditData] = useState(null);
  const columns = [
    {
      dataIndex: "customer_name",
      title: "Customer Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "loan_type",
      title: "Loan Type",
      render: (text) => {
        return <>{_enum.LOAN_TYPES_MAP[text]}</>;
      },
    },
    {
      dataIndex: "loan_amount",
      title: "Loan Amt.",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "source",
      title: "Source",
      display: ["PENDING"].includes(status) ? true : false,
    },
    {
      dataIndex: "assigned_agent",
      title: "Assigned To",
      display: ["ASSIGNED", "DISBURSED", "REJECTED"].includes(status)
        ? true
        : false,
      render: (_, record) => {
        return <>{record?.assigned_agent?.agent_name}</>;
      },
    },
    {
      dataIndex: "assigned_agent",
      title: "Agent Mobile No.",
      display: ["ASSIGNED", "DISBURSED", "REJECTED"].includes(status)
        ? true
        : false,
      render: (_, record) => {
        return <>{record?.assigned_agent?.mobile_number}</>;
      },
    },
    {
      dataIndex: "application_status",
      title: "Application Status",
      render: (text) => {
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
    {
      dataIndex: "disbursement_amount",
      title: "Disb. Amt.",
      display: ["DISBURSED"].includes(status) ? true : false,
      render: (text, record) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "disbursement_date",
      title: "Disb. Date",
      display: ["DISBURSED"].includes(status) ? true : false,
      render: (text, record) => {
        let dateStr = record?.disbursement_date || null;
        if (dateStr) {
          let date = new Date(dateStr).dateToDDMMYYYY(new Date(dateStr));
          return date;
        } else {
          return "-";
        }
      },
    },
  ];
  // ----------------------------------------------------------------

  const modalConfigs = {
    agentApplication: [
      {
        type: "section",
        label: "Customer Details",
        divider: false,
        colspan: 24,
        align: "end",
      },
      { type: "empty", colspan: 24 },
      {
        name: "customer_name",
        label: "Customer Name",
        type: "text",
        required: true,
      },
      {
        name: "mobile_number",
        label: "Mobile No.",
        type: "text",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
      },
      {
        name: "loan_type",
        label: "Loan Type",
        type: "select",
        // fetchOptions: () => props.apis.apiGetProductTypes(),
        options: _enum.AGENT_LOAN_TYPES,
        required: true,
      },
      {
        name: "loan_amount",
        label: "Loan Amount",
        type: "number",
        required: true,
      },
      {
        name: "source",
        label: "Source",
        type: "select",
        options: _enum.SOURCES,
        hide: status === "ASSIGNED" ? true : false,
      },
      {
        name: "agent_name",
        label: "Agent Name",
        type: "text",
        hide: status === "PENDING" ? true : false,
        readOnly: true,
      },
      {
        name: "agent_mobile_number",
        label: "Agent Mobile No.",
        type: "text",
        hide: status === "PENDING" ? true : false,
        readOnly: true,
      },
    ],
  };
  const dependencies = {};

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  const openApplicationModal = () => {
    let defaultValues = { source: "SELF" };
    openModal("agentApplication", "add", "Add Application", defaultValues);
  };

  const view = async (record) => {
    const data = await props.apis.apiGetAgentApplicationById({
      agent_application_id: record.agent_application_id,
    });
    setEditData(data);
    openModal("agentApplication", "view", "View Application", {
      ...data,
      agent_name: data?.assigned_agent?.agent_name,
      agent_mobile_number: data?.assigned_agent?.mobile_number,
    });
  };

  const edit = async (record) => {
    const data = await props.apis.apiGetAgentApplicationById({
      agent_application_id: record.agent_application_id,
    });
    setEditData(data);
    openModal("agentApplication", "edit", "Edit Application", {
      ...data,
      agent_name: data?.assigned_agent?.agent_name,
      agent_mobile_number: data?.assigned_agent?.mobile_number,
    });
  };

  const deleteApplication = (record) => {
    console.log({ deleteLead: record });
    swal2
      .fire({
        title: "Are you sure you want to delete this Application?",
        icon: "info",
        iconColor: "#234C9B",
        showCancelButton: true,
        confirmButtonColor: "#234C9B",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis
            .apiDeleteAgentApplication({
              agent_application_id: record.agent_application_id,
            })
            .then((res) => {
              swal2.fire({
                title: "Application Deleted",
                text: "Application deleted successfully !!",
                icon: "success",
                iconColor: "#234C9B",
                timer: 4000,
              });
              getData();
            });
        }
      });
  };

  const handleAppModalSubmit = async (data) => {
    if (modalState.mode === "edit" && modalState.type === "agentApplication") {
      let payload = {
        ...Object.except(data, ["agent_name", "agent_mobile_number"]),
      };
      const res = await props.apis.apiUpdateAgentApplication(payload, {
        agent_application_id: editData.agent_application_id,
      });
      if (res) {
        swal2.fire({
          title: "Application details updated successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getData();
      }
    } else if (modalState.mode === "add") {
      const res = await props.apis.apiAddAgentApplication(data);
      if (res) {
        swal2.fire({
          title: "Application details added successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getData();
      }
    }
  };

  // ----------------------------------------------------------------
  // ASSIGN TO
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assignedToId, setAssignedToId] = useState(null);
  const [assigntoform] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    assigntoform.resetFields();
  };

  const openAssignedToModal = (record) => {
    setAssignedToId([record?.agent_application_id]);
    getAgents();
    showModal();
  };

  const getAgents = async () => {
    const res = await props.apis.apiGetAgents();
    if (res) {
      const agentsList = res?.data;
      console.log({ agentsList });
      setAgents(agentsList.options("agent_id", "agent_name"));
    }
  };

  const handleAssignedTo = async (value) => {
    const payload = {
      assigned_agent_id: value?.assignedTo || "",
      application_status: "ASSIGNED",
    };
    console.log("Success:", value, payload);
    if (value?.assignedTo === null || value?.assignedTo === "") {
      swal2.fire({
        title: "Please select any agents",
        icon: "info",
        iconColor: "#008AD1",
      });
      return;
    } else {
      const res = await props.apis.apiUpdateAgentApplication(payload, {
        agent_application_id: assignedToId,
      });
      if (res) {
        swal2.fire({
          title: "Application assigned to agent successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        assigntoform.resetFields();
        setIsModalOpen(false);
        getData();
      }
    }
  };

  const getData = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["page", "limit"]);
      setSearch(defaultSearchData);
      payload = { ...defaultSearchData };
    } else {
      payload = { ...search, ...params };
    }

    props.apis
      .apiGetAgentApplications({
        ...payload,
        application_status: status, // 👈 dynamic filter
      })
      .then(({ data, count }) => {
        setData(data);
        setRowcount(count);
        setIsFetching(false);
      });
  };

  const onSearch = (data, reset) => {
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    }
  };

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  // ----------------------------------------------------------------

  useEffect(() => {
    // whenever tab changes AND this wrapper is active → call API
    if (props.activeKey === status.toLowerCase()) {
      getData();
    }
  }, [props.activeKey, status]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-end mb-3 float_top_lg top-60px">
        <AgentApplicationSearch
          onSearch={(...arg) => onSearch(...arg)}
          openApplicationModal={openApplicationModal}
        />
        {status === "PENDING" && (
          <div>
            <Button
              type="primary"
              className="btn btn-primary"
              htmlType="button"
              onClick={(...args) => openApplicationModal(...args)}
            >
              Add Application
            </Button>
          </div>
        )}
      </div>

      <AppTable
        data={data}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        viewAction={(e) => view(e)}
        editAction={(e) => edit(e)}
        deleteAction={(e) => deleteApplication(e)}
        assignedToLink={true}
        assignedToLinkAction={(e) => openAssignedToModal(e)}
        loading={isFetching}
      />

      {/* Modals*/}
      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
        persona={props?.$store?.user?.role}
      />

      {/* ASSIGN TO MODAL */}
      <Modal
        title=""
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onCancel={handleCancel}
        cancelButtonProps={{ style: { display: "none" } }}
        centered
        footer={null}
      >
        <Form
          form={assigntoform}
          layout="vertical"
          onFinish={handleAssignedTo}
          autoComplete="off"
        >
          <Form.Item
            label="Assign To"
            name="assignedTo"
            rules={[{ required: true, message: "Please select a value" }]}
          >
            <Select
              name="assignedTo"
              placeholder="Assign To"
              options={agents?.map((v) => ({
                value: v.key,
                label: v.label,
              }))}
              style={{ width: "100%" }}
              allowClear
              size="large"
              required={true}
            />
          </Form.Item>
          <Form.Item>
            <Button
              className="btn btn-primary"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default constore(AgentApplication);
